import isNull from 'lodash/isNull';
import isString from 'lodash/isString';

import type { IAutoVariables, IAutoVariable } from '../../interfaces';

export function sortAutoCoverageVarValues(
  variables: IAutoVariables
): IAutoVariables {
  function getSortedMedicalLimit() {
    const { medical_limit: medicalLimit } = variables;
    const normalValues: IAutoVariable['values'] = [];
    const excessValues: IAutoVariable['values'] = [];

    medicalLimit.values.forEach((v) => {
      if (isNull(v)) {
        normalValues.push(v);
      }
      if (isString(v) && !v.toLowerCase().includes('excess')) {
        normalValues.push(v);
      }
      if (isString(v) && v.toLowerCase().includes('excess')) {
        excessValues.push(v);
      }
    });

    return {
      ...medicalLimit,
      values: [...normalValues, ...excessValues],
    };
  }

  return {
    ...variables,
    ...('medical_limit' in variables && {
      medical_limit: getSortedMedicalLimit(),
    }),
  };
}
